




import TWEEN from 'tween.js'
Currency = require 'models/currency.coffee'

export default {
  name: 'balance'
  props: ['amount', 'currency', 'color', 'sign', 'animation']
  data: ->
    animatedNumber: @amount
  computed:
    fAmount: -> Currency.format
      value: @animatedNumber
      currency: (@currency || @$store.getters.default_currency)
      color: @color || 'neutral'
      sign: @sign
  watch:
    amount: (newValue, oldValue) ->
      if @animation == false
        @animatedNumber = newValue
        return
      vm = this
      animationFrame = null
      animate = (time) ->
        TWEEN.update(time)
        animationFrame = requestAnimationFrame(animate)

      animation_length = 500

      new TWEEN.Tween({ tweeningNumber: oldValue })
        .easing(TWEEN.Easing.Quadratic.Out)
        .to({ tweeningNumber: newValue }, animation_length)
        .onUpdate( -> vm.animatedNumber = this.tweeningNumber )
        .onComplete (-> cancelAnimationFrame(animationFrame))
        .start()
      animationFrame = requestAnimationFrame(animate)
}
